import axios from '../axios'
import { getFullURL, jsonToParam ,getURL} from 'src/utils/config';
import { handleResponse } from 'src/utils/responseHandler';

const addFaceDetails = (baseURL, body, callback) => {
    axios({
        method: 'post',
        url: getFullURL('face-registration/add'),
        data: body,
        validateStatus: (status) => handleResponse(status)
    }).then((response) => callback(true, response)).catch((error) => callback(false, error))
}

const getFaceList = (data, callback) => {
    const { location_id} = data
    axios({
        method: 'get',
        url: `${getURL('face-registration')}?location_id=${location_id}`,
        validateStatus: (status) => handleResponse(status)
    }).then((response) => callback(true, response)).catch((error) => callback(false, error))
}


const registerFace = (body, callback) => {
    axios({
        method: 'get',
        url: `${getFullURL('register-face-id', 'FACE_API')}?${jsonToParam(body)}`,
        validateStatus: (status) => handleResponse(status)
    }).then((response) => callback(response)).catch((error) => callback(error))
}

const registerFaceManually = (body,baseURL, callback) => {
    const formData = new FormData();
    
    // Append images to FormData (assuming body.images is an array of File objects)
    body.images.forEach((image) => {
        formData.append('images', image);
    });

    axios({
        method: 'post',
        url: `${baseURL}/register-face-manually?client_id=${body.client_id}&user_id=${body.user_id}`,
        data: formData,
        headers: {
            'Content-Type': 'multipart/form-data', 
        },
        validateStatus: (status) => handleResponse(status)
    })
    .then((response) => callback(response))
    .catch((error) => callback(error));
};


const registerWithSelectedImages = (baseURL,body, callback) => {
    axios({
        method: 'post',
        url: `${baseURL}/register-selected-faces`,
        data: body,
        validateStatus: (status) => handleResponse(status)
    }).then((response) => callback(response)).catch((error) => callback(error))
}


const updateUserDataFc = (body, callback) => {
    axios({
        method: 'put',
        url: getURL('face-registration/update'),
        data: body,
        validateStatus: (status) => handleResponse(status)
    }).then((response) => callback(response))
}


const updateUserDataFcDelete = (body, callback) => {
    const { client_id , user_id} = body
    const deleteURL = localStorage.getItem('deleteURL');

    axios({
        method: 'delete',
        url : `${deleteURL}/delete-face?client_id=${client_id}&user_id=${user_id}`,
        validateStatus: (status) => handleResponse(status)
    }).then((response) => callback(response))
}

const getEntryAndExit = (data, callback) => {
    const { location_id , limit, last_updated_time} = data
    axios({
        method: 'get',
        url: `${getURL('face-registration/get-face-time-track')}?location_id=${location_id}&limit=${limit}&last_updated_time=${last_updated_time}`,
        validateStatus: (status) => handleResponse(status)
    }).then((response) => callback(response))
}

const getEntryAndExitTotal = (callback) => {
    axios({
        method: 'get',
        url: `${getURL('face-registration/get-face-time-track')}`,
        validateStatus: (status) => handleResponse(status)
    }).then((response) => callback(response))
}

const getEntryAndExitTotalDateWise = (data,callback) => {
    const { location_id , date} = data
    axios({
        method: 'get',
        url: `${getURL('face-registration/get-face-time-track')}?location_id=${location_id}&date=${date}`,
        validateStatus: (status) => handleResponse(status)
    }).then((response) => callback(response))
}


const getEmployeeTrackingInfo = (data, callback) => {
    const { location_id, from_time, to_time } = data
    axios({
        method: 'get',
        url: `${getURL('face-registration/get-face-time-summary')}?location_id=${location_id}&from_time=${from_time}&to_time=${to_time}`,
        validateStatus: (status) => handleResponse(status)
    }).then((response) => callback(response))
}


const getEmployeeProduction = (data, callback) => {
    const { location_id, from_date, to_date,department_id } = data
    axios({
        method: 'get',
        url: `${getURL('face-registration/department-wise-attendance')}?location_id=${location_id}&from_date=${from_date}&to_date=${to_date}&department_id=${department_id}`,
        validateStatus: (status) => handleResponse(status)
    }).then((response) => callback(response))
}


const getEmployeeMusterRoll = (data, callback) => {
    const { location_id, month, year,department_id } = data
    axios({
        method: 'get',
        url: `${getURL('face-registration/employee-attendance-summary')}?location_id=${location_id}&month=${month}&year=${year}&department_id=${department_id}`,
        validateStatus: (status) => handleResponse(status)
    }).then((response) => callback(response))
}

const getEmployeeOverTime = (data, callback) => {
    const { location_id, from_date,to_date,department_id } = data
    axios({
        method: 'get',
        url: `${getURL('face-registration/employee-overtime-summary')}?location_id=${location_id}&from_date=${from_date}&to_date=${to_date}&department_id=${department_id}`,
        validateStatus: (status) => handleResponse(status)
    }).then((response) => callback(response))
}

const getEmployeeMonthlyData = (data, callback) => {
    const { location_id,department_id,year,month } = data
    axios({
        method: 'get',
        url: `${getURL('face-registration/employee-monthly-attendance')}?location_id=${location_id}&year=${year}&month=${month}&department_id=${department_id}`,
        validateStatus: (status) => handleResponse(status)
    }).then((response) => callback(response))
}

const getEmployeeAttendanceTrend = (data, callback) => {
    const { location_id,department_id,year,month } = data
    axios({
        method: 'get',
        url: `${getURL('face-registration/monthly-attendance-trend')}?location_id=${location_id}&year=${year}&month=${month}&department_id=${department_id}`,
        validateStatus: (status) => handleResponse(status)
    }).then((response) => callback(response))
}

const getEmployeeBreakSummary = (data, callback) => {
    const { location_id,department_id,year,month } = data
    axios({
        method: 'get',
        url: `${getURL('face-registration/employee-breaks-summary')}?location_id=${location_id}&year=${year}&month=${month}&department_id=${department_id}`,
        validateStatus: (status) => handleResponse(status)
    }).then((response) => callback(response))
}

const getEmployeeLateEarly = (data, callback) => {
    const { location_id,date,department_id } = data
    axios({
        method: 'get',
        url: `${getURL('face-registration/employee-attendance-exceptions')}?location_id=${location_id}&date=${date}&department_id=${department_id}`,
        validateStatus: (status) => handleResponse(status)
    }).then((response) => callback(response))
}

const getDepartmentsByLocation = (data, callback) => {
    const { location_id } = data
    axios({
        method: 'get',
        url: `${getURL('face-registration/get-departments-by-location')}?location_id=${location_id}`,
        validateStatus: (status) => handleResponse(status)
    })
        .then((response) => callback(response))
        .catch((error) => callback(error.response || { status: 500, data: [] }))
}

const getContractorsByLocation = (data, callback) => {
    const { location_id } = data
    axios({
        method: 'get',
        url: `${getURL('face-registration/get-contractors-by-location')}?location_id=${location_id}`,
        validateStatus: (status) => handleResponse(status)
    })
        .then((response) => callback(response))
        .catch((error) => callback(error.response || { status: 500, data: [] }))
}



const registerFaceUpdate = (callback) => {
    const port = process.env.REACT_APP_PORT;
    const ip = localStorage.getItem('netIP');

    if (ip && port) {
        try {
            // Ensure the URL has a protocol
            const baseUrl = ip.startsWith('http') ? ip : `http://${ip}`;

            const urlObject = new URL(baseUrl);
            urlObject.port = port;

            const fullUrl = `${urlObject.protocol}//${urlObject.hostname}:${urlObject.port}/update-data`;

            console.log("fullUrl:", fullUrl);
            
            axios({
                method: 'get',
                url: fullUrl,
                validateStatus: (status) => handleResponse(status)
            })
            .then((response) => callback(response))
            .catch((error) => callback(error));
        } catch (error) {
            console.error("Invalid IP or URL format:", error);
        }
    } else {
        console.error("Missing IP or port.");
    }


    // const port = process.env.REACT_APP_PORT;
    // const ip = localStorage.getItem('netIP');

    // // Remove port from original URL if present
    // const urlObject = new URL(url);
    // urlObject.port = port; // Set the desired port

    // // Append the path
    // const fullUrl = `${urlObject.origin}${urlObject.pathname.replace(/\/$/, '')}/update-data`;
    // console.log("fullUrl",fullUrl)
    // axios({
    //     method: 'get',
    //     url: fullUrl,
    //     validateStatus: (status) => handleResponse(status)
    // })
    // .then((response) => callback(response))
    // .catch((error) => callback(error));
};


const registerFaceStatus = (data,callback) => {
const port = process.env.REACT_APP_PORT;
const ip = localStorage.getItem('netIP');
const {status} = data;

if (ip && port) {
  try {
    // Ensure the URL has a protocol
    const baseUrl = ip.startsWith('http') ? ip : `http://${ip}`;

    const urlObject = new URL(baseUrl);
    urlObject.port = port;

    const fullUrl = `${urlObject.protocol}//${urlObject.hostname}:${urlObject.port}/process/${status}`;
    console.log("fullUrl:", fullUrl);
    axios({
        method: 'get',
        url: fullUrl,
        validateStatus: (status) => handleResponse(status)
    })
    .then((response) => callback(response))
    .catch((error) => callback(error));
  } catch (error) {
    console.error("Invalid IP or URL format:", error);
  }
} else {
  console.error("Missing IP or port.");
}

};

export {getEmployeeTrackingInfo,getEmployeeBreakSummary,getEmployeeAttendanceTrend,getEmployeeOverTime,getEmployeeMusterRoll,getEmployeeLateEarly,getEmployeeMonthlyData,registerFaceStatus,getEmployeeProduction, getDepartmentsByLocation, getContractorsByLocation, addFaceDetails, registerFace, registerFaceManually, registerWithSelectedImages, getFaceList ,updateUserDataFc ,getEntryAndExit ,getEntryAndExitTotal ,updateUserDataFcDelete,getEntryAndExitTotalDateWise ,registerFaceUpdate}
